import {h, Fragment} from "preact"
import { useFacets, useSort } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"
import SortInsideSidebar from './elements/SortInsideSidebar'
import { useProductFilters } from "@nosto/preact"
import { sortOptions } from "../config"
import { useState } from "preact/hooks"



export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            for={toggleButtonId}
        >
            <Icon name="close" />
        </label>
    )
}

export default function SideBar() {
    const { loading, facets } = useFacets()

    const { filters, removeAll } = useProductFilters()

    const { activeSort, setSort } = useSort(sortOptions)

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    const [activeFacetId, setActiveFacetId] = useState(null)

    console.log("FILTERS", filters)

    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black "
                htmlFor={toggleButtonId}
            />
            <div
                class="ns-sidebar-wrapper  ns-d-md-block ns-h-100 ns-col-3 ns-col-l-2"
                style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline ns-p-4">
                        <span class="ns-font-medium ns-font-5 ns-color-black">Filters</span>
                        <ToggleSidebarButton />
                    </div>
                    <div class="ns-sidebar-menu">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            <li>
                                <SortInsideSidebar value={activeSort}
                                className="ns-selection-dropdown-sort-menu"
                                options={options}
                                label={"Sort by"}/>
                            </li>
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet key={facet.id} facet={facet} />
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet} />
                                    default:
                                        return null
                                }
                                })}
                        </ul>
                    </div>
                    {filters.length > 0 && <div class="ns-facets-buttons-container ns-p-4">
                        <button class="ns-clear-facets btn btn--secondary btn--large" onClick={() => {
                        removeAll()
                    }}>Clear filters</button>
                        <button class="ns-apply-facets btn btn--primary btn--large" onClick={()=>{ document.querySelector(".ns-close-sidebar").click()}}>Apply filters</button>
                    </div>}
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
